import React, {useEffect, useState} from 'react';
import {Container, Col, Row, Button} from 'reactstrap';
import {subscribeToCampaign} from 'react-controlled-ab/datalayers/vwo';

import {usePhaseState} from 'funnel-schedule/phase-context';
import {useUserState} from 'contexts/user';
import useBalanceText from 'utils/useBalanceText';
import useBeacon from 'utils/useBeacon';
import track from 'utils/track';

import PageMeta from 'components/PageMeta';
import Header from 'components/Elements/Header';
import SectionCL from 'components/ComponentLibrary/SectionCL';
import Video from 'components/Video';
import SalesCopy from 'components/SalesCopy';
import ModalExitScreening from 'components/Modals/ModalExitScreening';
import Footer from 'components/Elements/Footer';

export default function ScreeningIndex({replayOverride = false, bucketOverride = null, ...props}) {
  const {
    phases: {
      default: defaultSchedule = {
        phase: 'before'
      },
      webinar: webinarSchedule = {
        phase: 'before'
      }
    }
  } = usePhaseState();

  const {bucket: userBucket, events = []} = useUserState();
  const {report: webinarReport} = webinarSchedule;
  const [anchorScrolled, setAnchorScrolled] = useState(false);

  const userSegment = bucketOverride ?? userBucket ?? 'health';
  const segment = userSegment === 'default' ? 'health' : userSegment;

  const productID = 'SC-PPP';
  const productSku = 'SC-PPP';
  const productName = 'Plant-Powered Playbook';
  const productSlug = 'ppp-27-masterclass';
  const productValue = 27;
  const paymentPlanPrice = 0;

  useEffect(() => {
    track('Product Viewed', {
      product_id: productID,
      sku: productSku,
      name: productName,
      variant: productSlug,
      value: productValue,
      currency: 'usd'
    });
  });

  useEffect(() => {
    if (anchorScrolled) {
      setAnchorScrolled(true);
      if (window !== undefined && window.location.hash === '#join') {
        document.getElementById('offer-cta-1').scrollIntoView();
      }
    }
  }, [events, anchorScrolled]);

  const pageTitle = 'Watch the Mini-Masterclass';
  const pageDescription = (
    <>
      {
        {
          curious: 'Watch the Mini-Masterclass — airing now for free',
          sustainability: 'Watch the mini-masterclass — airing now for free',
          health: 'Watch this free mini-masterclass to learn what to eat to feel good again.'
        }[segment]
      }
    </>
  );
  const ogImage = (
    <>
      {
        {
          curious: 'https://cdn.foodrevolution.org/ppp/og/ppp-opengraph-Veg-curious-1200x1200-v20221025.jpg',
          sustainability:
            'https://cdn.foodrevolution.org/ppp/og/ppp-opengraph-Sustainability-minded-1200x1200-v20221025.jpg',
          health: 'https://cdn.foodrevolution.org/ppp/og/ppp-opengraph-health-motivated-1200x1200-v20221025.jpg'
        }[segment]
      }
    </>
  );
  const shareUrl = (
    <>
      {
        {
          curious: 'https://plantplaybook.foodrevolution.org/masterclass/plantbased/',
          sustainability: 'https://plantplaybook.foodrevolution.org/masterclass/sustainability/',
          health: 'https://plantplaybook.foodrevolution.org/masterclass/health/'
        }[segment]
      }
    </>
  );

  useBalanceText();
  useBeacon();
  return (
    <div className="page page-nosocial d-flex flex-column">
      <PageMeta title={pageTitle} description={pageDescription} url={shareUrl} ogImage={ogImage} />

      <div className="page-content">
        <Header bgColor="black" lockupWhite />

        <SectionCL id="screening-header-cta" color="white" order="first" type="triangle">
          <Container>
            <Row>
              <Col className="text-center">
                <h2 className="section-heading mb-4">
                  {
                    {
                      curious: <>What’s so great about going plant-based?</>,
                      sustainability: <>How your food choices can help save the planet (for real!)</>,
                      health: <>How to feel awesome with a plant-based diet</>
                    }[segment]
                  }
                </h2>
                <p className="balance-text mb-5">
                  <i>A Mini-Masterclass</i> with best-selling author and Food Revolution Network Co-Founder Ocean
                  Robbins
                </p>
              </Col>
            </Row>
            <Row className="d-flex justify-content-center">
              <Col lg="10" className="video-col px-0 px-sm-3">
                <Video
                  url={
                    {
                      curious: 'https://www.youtube.com/watch?v=0PuDjHfMMg0',
                      sustainability: 'https://www.youtube.com/watch?v=zgZfSsQYJps',
                      health: 'https://www.youtube.com/watch?v=nwa0T8Rs-4c'
                    }[segment]
                  }
                  label={
                    {
                      curious: 'PPP - Masterclass - Veg Curious',
                      sustainability: 'PPP - Masterclass - Sustainability-minded',
                      health: 'PPP - Masterclass - Health-motivated'
                    }[segment]
                  }
                  playing
                />
              </Col>
            </Row>
          </Container>
        </SectionCL>

        {!replayOverride ? (
          <>
            <SalesCopy
              version="screening"
              productId={productID}
              productSku={productSku}
              productSlug={productSlug}
              productPrice={productValue}
              paymentPlanPrice={paymentPlanPrice}
            />
          </>
        ) : null}
      </div>

      {replayOverride ? (
        <SectionCL
          id="replay-cta"
          color="purple"
          innerClass="text-center text-white"
          type="triangle"
          angle="none"
          order="last"
        >
          <Container>
            <Row>
              <Col>
                <h4 className="section-heading">
                  Are you interested in getting the <i>Plant-Powered Playbook</i>?
                </h4>
                <h5>Click below to learn more:</h5>
                <Button className="btn-join btn-lg" color="cta" href="/join/" target="_blank">
                  Join Now!
                </Button>
              </Col>
            </Row>
          </Container>
        </SectionCL>
      ) : (
        <>{!replayOverride ? <ModalExitScreening /> : null}</>
      )}

      <div className="footer-content mt-auto">
        <Footer />
      </div>
    </div>
  );
}
